import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { FlashMessagesService } from 'flash-messages-angular';
import { NavbarComponent } from 'angular-bootstrap-md';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

  @ViewChild(NavbarComponent, { static: true })
  navbar!: NavbarComponent;

  askHousingProviderUrl = environment.tawk.knowledgeBaseUrl;

  constructor(private route: Router, public auth: AuthService, private flashMessage: FlashMessagesService) { }

  ngOnInit(): void {
    console.log("navbar initialized")
  }

  // Logout through auth service
  onLogout() {
    if (confirm("Are you sure you want to log out?")) {
      this.auth.logout();

      // Display success flash message
      this.flashMessage.show("You have been logged out.", {
        cssClass: 'alert-success',
        timeout: 3000
      });

      this.route.navigate(['/login']);
      this.navbar.hide();
    }
  }

  @HostListener('window:click', ['$event'])
  @HostListener('window:touchend', ['$event'])
  onClick(event: MouseEvent) {
    this.navbar.hide();
  }
}
